import { Directive, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';

import { DatePicker } from 'primeng/datepicker';
import { Observable } from 'rxjs';

import { SDate } from '@summit/core';
import { IUserExperience, SummitIdObject, SummitUserExperienceService } from '@summit/models';

import dayjs from 'dayjs';
import { SummitControl } from './summit-control';

@Directive()
export abstract class SummitDateControl<T extends SummitIdObject> extends SummitControl<T> implements OnInit {
  protected dateValue?: Date;
  @ViewChild('dateControl') dateControl: DatePicker;
  @Input() leaveTimeAlone = false;
  isMobile: Observable<boolean>;
  defaultDate: Date = new Date(1970, 0, 1); //needed to start at 00:00:00
  isOpen: boolean;
  @Output() DateChange: EventEmitter<dayjs.Dayjs | null> = new EventEmitter<dayjs.Dayjs | null>();

  constructor() {
    super();
    const uxService = inject(SummitUserExperienceService<IUserExperience>);
    this.isMobile = uxService.isMobile;
  }

  override ngOnInit() {
    super.ngOnInit();
    this.displayHint ??= this.attribute?.displayHint ?? '';
  }

  onShow(_) {
    this.isOpen = true;
  }
  onClose(_) {
    this.isOpen = false;
  }

  onBlur(_) {
    if (!this.isOpen) {
      const rawString = this.dateControl?.inputfieldViewChild?.nativeElement?.value;
      if (rawString && rawString.length > 0) {
        this.updateValue(rawString);
      }
    }
  }

  updateValue(value: Date | string) {
    const newValue = SDate.newUtc(value);
    this.form?.controls[this.fieldName ?? '']?.setValue(newValue);
    this.DateChange.emit(newValue);
  }
}
